import ScrollNavigation from '@resources/js/ScrollNavigation'

// скрол для навігації
new ScrollNavigation({
	menuItemsSelector: '[data-scroll-trigger]',
	menuItemsAttr: 'data-scroll-trigger',
	blocksSelector: '[data-scroll-target]',
	blocksAttr: 'data-scroll-target',
})
